import * as actionTypes from 'constants/historicalConversationActionTypes';

const displayingHistoricalConversation = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ACTIVATE_HISTORICAL_TICKET:
      return true;
    case actionTypes.DEACTIVATE_HISTORICAL_TICKET:
    case actionTypes.CLEAR_ALL_TICKET:
      return false;
    default:
      return state;
  }
};

export default displayingHistoricalConversation;
